export async function splcalc(container = null) {

    if (!container) {
        document.querySelectorAll("div#splcalc").forEach(splcalc);
        return;
    }

    const formatter = new Intl.NumberFormat('en-US');
    if (container.dataset.splcalcInitialized === "true") return;
    container.dataset.splcalcInitialized = "true";
    const instanceId = Array.from(document.querySelectorAll("div#splcalc")).indexOf(container);
    const radioForm = document.createElement("form");
    radioForm.id = "splcalc-radio-form-" + instanceId;
    radioForm.hidden = true;
    container.appendChild(radioForm);
    container.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const originalId = radio.id;
        const uniqueId = originalId + "-splcalc-" + instanceId;
        const defaultChecked = radio.defaultChecked;
        radio.id = uniqueId;
        radio.dataset.splcalcId = originalId;
        radio.setAttribute("form", radioForm.id);
        container.querySelector('label[for="' + originalId + '"]').htmlFor = uniqueId;
        if (defaultChecked) radio.checked = true;
    });
    const splCalcNonce = container.dataset.splcalcNonce || "";
    const overlay = container.querySelector("#overlay")
    const headings = container.querySelectorAll("h2, #intro p");
    const fields = container.querySelectorAll("input:not([type='radio']), select");
    const nextButton = container.querySelector("a#next");
    const errorMsg = container.querySelector("p.error");
    const steps = container.querySelectorAll("div.step");
    const fieldsets = container.querySelectorAll("fieldset");
    const carPaid = container.querySelectorAll("input[name='loan_paid_off']");
    const soleOwner = container.querySelectorAll("input[name='only_owner']");
    const ownCar = container.querySelectorAll("input[name='own_car']");
    const useCar = container.querySelectorAll("input[name='use_car']");
    const loanAmount = container.querySelector("#loan_amount");
    const loanAmountRange = container.querySelector("#loan_amount_range");
    let loanAmountRangeChange = false;
    const entryTypes = container.querySelectorAll("div.car-entry");
    const carLookUp = container.querySelectorAll('input[name="car_lookup"]')
    const carYear = container.querySelector("select#car_year");
    const carMake = container.querySelector("select#car_make");
    const carModel = container.querySelector("select#car_model");
    const carTrim = container.querySelector("select#car_trim");
    const carMileage = container.querySelector("input#car_mileage");
    const carZip = container.querySelector("input#zip");
    const licensePlate = container.querySelector("input#license_plate");
    const licenseState = container.querySelector("select#license_state");
    const vinNumber = container.querySelector("input#vin_field");
    const vehicleConfirm = container.querySelector("div#vehicle-confirm");
    const confirmMileage = container.querySelector("input#confirm_mileage");
    const confirmZip = container.querySelector("input#confirm_zip");
    const vehicleTitle = container.querySelector("span.vehicle-title");
    const no_collateral = container.querySelector("#no_collateral");
    const no_collateralHeader = container.querySelector("img.header-image.declined");
    const approved = container.querySelector("#approved");
    const approvedHeader = container.querySelector("img.header-image.approved");
    const approvedRange = approved.querySelector("p.amount");
    const approvalCar = approved.querySelector("span#approval-car");
    const splApplyLink = container.querySelector("a#splapply");
    const resetLink = container.querySelectorAll(".car_reset");
    const notYourLink = container.querySelector("#not-your");
    const rangeType = container.dataset.rangetype;
    const calcVersion = container.dataset.calcversion;
    let continueText = "Continue";
    let searchText = "Search";
    let noMatch = "We could not find a match";
    let toText = "to";
    let invalidVinText = "VIN is Invalid";
    if(document.documentElement.lang !== 'en-US'){
        continueText = "Continuar";
        searchText = "Buscar";
        noMatch = "No encontramos resultados";
        toText = "a";
        invalidVinText = "El VIN no es válido";
    }
    let selectedYear = 0;
    let selectedMakeId = 0;
    let selectedMakeStr = "";
    let selectedModelId = 0;
    let selectedModelStr = "";
    let selectedTrimId = 0;
    let selectedTrimStr = "";
    let selectedVin = 0;
    let selectedVendorId = 0;

    let formStep = 0;
    let callOnce = false;
    const splCalcAllowedFetchPaths = new Set([
        "/wp-json/splcalc/vehicle-years",
        "/wp-json/splcalc/vehicle-make",
        "/wp-json/splcalc/vehicle-model",
        "/wp-json/splcalc/vehicle-trim",
        "/wp-json/splcalc/vehicle-validate",
        "/wp-json/splcalc/license-states",
        "/wp-json/splcalc/license-validate",
        "/wp-json/splcalc/vin-validate"
    ]);

    if(calcVersion == "v4"){
        formStep = 1;
        container.querySelector("#step" + formStep).style.display = "block";  
    }

    function splCalcFetch(url, options = {}) {
        let requestUrl;

        try {
            requestUrl = new URL(url, window.location.origin);
        } catch {
            return Promise.reject(new Error("Invalid SPL calculator request URL."));
        }

        if (requestUrl.origin !== window.location.origin || !splCalcAllowedFetchPaths.has(requestUrl.pathname)) {
            return Promise.reject(new Error("Invalid SPL calculator request URL."));
        }

        const headers = new Headers(options.headers || {});

        if (splCalcNonce) {
            headers.set("X-OCW-SPL-Nonce", splCalcNonce);
        }

        return fetch(requestUrl.toString(), Object.assign({}, options, { headers }));
    }

    if(fields){
        fields.forEach( (e) => {
            if(e.getAttribute("type") !== "range"){
                togglePlaceholder(e);
            }

            e.addEventListener("input", () => togglePlaceholder(e));
            e.addEventListener("change", () => togglePlaceholder(e));
            if (e.tagName === "INPUT" && e.getAttribute("type") !== "range") {
                e.addEventListener("focus", function(input){
                    input.target.closest("fieldset").classList.add("has-value");
                });

                e.addEventListener("blur", function(input){
                    if(!input.target.value){
                        input.target.closest("fieldset").classList.remove("has-value");
                    }
                });
            }
        });
    }

    if(useCar){
        useCar.forEach((radio) => {
            radio.addEventListener("change", (e) => {
                if(e.currentTarget.value == "no"){
                    container.querySelector("#try_again").style.display = "none";
                    showDeclined();
                }else if(e.currentTarget.value == "yes"){
                    container.querySelector("input[name='loan_paid_off']").closest('fieldset').style.display = "block";
                }
            });
        });
    }

    if(loanAmountRange){
        barColor(loanAmountRange);
        if ("oninput" in loanAmountRange) {
            loanAmountRange.addEventListener("input", function(e) {
                barColor(this);
            }, false);
        }

        loanAmountRange.addEventListener("change", function(e){
            loanAmountRangeChange = true;
            barColor(this);
        });
    }

    function barColor(sliderElement){
        let value = (sliderElement.value-sliderElement.min)/(sliderElement.max-sliderElement.min)*100;
        sliderElement.style.background = 'linear-gradient(to right, var(--green-300) 0%, var(--green-300) ' + value + '%, #d3d3d3 ' + value + '%, #d3d3d3 100%)';
        sliderElement.setAttribute("aria-valuenow", sliderElement.value);
        container.querySelector("#how_much_value").textContent = "$" + formatter.format(sliderElement.value);
    }

    if(nextButton){
        nextButton.addEventListener("click", showNextStep );
    }
    
    if(loanAmount){
        loanAmount.addEventListener("keyup", function(e){
            this.value = "$" + formatter.format(this.value.replace(/[^0-9]/g, ''));
            if(this.value){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(carLookUp){
        carLookUp.forEach( (radio) => {
            radio.addEventListener("change", (e) => {
                resetConfirm(e);
                errorMsg.textContent = "";
                errorMsg.style.display = "none";
                licensePlate.classList.remove("error");
                vinNumber.classList.remove("error");

                entryTypes.forEach( (div) => {
                    div.style.display = "none";
                });
                const entryType = container.querySelector('input[name="car_lookup"]:checked').value;
                container.querySelector('.' + entryType + '-fields').style.display = "flex";
                if(entryType == "manual"){
                    nextButton.textContent = continueText;
                }else{
                    nextButton.textContent = searchText;
                }
            });
        })
    }

    if(carYear){
        getYears();
        carYear.addEventListener("change", () => {
           getMakes(carYear.value); 
        });
    }

    if(carMake){
        carMake.addEventListener("change", () => {
           getModels(carYear.value, carMake.value); 
        });
    }

    if(carModel){
        carModel.addEventListener("change", () => {
           getTrim(carYear.value, carMake.value, carModel.value); 
        });
    }

    if(carTrim){
        carTrim.addEventListener("change", () => {
            if(carTrim.value){
                carTrim.options[0].disabled = true;
                carMileage.disabled = false;
                carZip.disabled = false;
                if(carMileage.value && carZip.value){
                    nextButton.classList.remove("disabled");
                }
            }
        });
    }

    if(carMileage){
        carMileage.addEventListener("keyup", function(e){
            this.value = formatter.format(this.value.replace(/[^0-9]/g, ''));
            if(this.value && carZip.value.length == 5){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(carZip){
        carZip.addEventListener("keyup", function(e){
            if(carMileage.value && this.value.length == 5){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(licensePlate){
        licensePlate.addEventListener("keyup", () => {
            if(licensePlate.value && licenseState.querySelector("option:checked").value){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(licenseState){
        getStates();
        licenseState.addEventListener("change", () => {
            if(licenseState.querySelector("option:checked")){
                licenseState.options[0].disabled = true;
            }

            if(licensePlate.value && licenseState.querySelector("option:checked").value){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(vinNumber){
        vinNumber.addEventListener("keyup", () => {
            const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
            if(vinRegex.test(vinNumber.value)){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(confirmMileage){
        confirmMileage.addEventListener("keyup", function(e){
            this.value = formatter.format(this.value.replace(/[^0-9]/g, ''));
            if(this.value && confirmZip.value.length == 5){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(confirmZip){
        confirmZip.addEventListener("keyup", function(e){
            if(confirmMileage.value && this.value.length == 5){
                nextButton.classList.remove("disabled");
            }else{
                nextButton.classList.add("disabled");
            }
        });
    }

    if(resetLink){
        resetLink.forEach( (link) => {
            link.addEventListener("click", reset)
        });
    }

    if(notYourLink){
        notYourLink.addEventListener("click", resetConfirm);
    }

    if(calcVersion == 'own-car' || calcVersion == 'v2' || calcVersion == 'v3'){
        ownCar.forEach((radio) => {
            radio.addEventListener("change", (e) => {
                if(e.currentTarget.value == "no"){
                    //Below is left to go back to changing the bar with the answer instead of just showing declined.
                    /*if(loanAmountRangeChange){
                        if(loanAmountRange.value > 10000){
                            loanAmountRange.value = "10000";
                        }
                    }else{
                        loanAmountRange.value = "300";
                        nextButton.classList.remove("disabled");
                        barColor(loanAmountRange);
                    }
                    loanAmountRange.max = "10000";
                    nextButton.classList.remove("disabled");
                    barColor(loanAmountRange);*/
                    container.querySelector("#try_again").style.display = "none";
                    showDeclined();
                }else if(e.currentTarget.value == "yes"){
                    if(!loanAmountRangeChange){
                        loanAmountRange.value = "300";
                    }
                    loanAmountRange.max = "18500";
                    nextButton.classList.remove("disabled");
                    barColor(loanAmountRange);
                }
            });
        });

        carPaid.forEach((radio) => {
            radio.addEventListener("change", function(e){
                if(e.currentTarget.value == "no"){
                    showDeclined();
                }else{
                    container.querySelector("input[name='only_owner']").closest("fieldset").style.display = "block";
                    radiosChecked();
                }
            });
        });

        soleOwner.forEach((radio) => {
            radio.addEventListener("change", function(e){
                if(e.currentTarget.value == "no"){
                    showDeclined();
                }else{
                    radiosChecked();
                }
            });
        });

        function radiosChecked(){
            const ownCarValue = container.querySelector("input[name='own_car']:checked");
            const ownerValue = container.querySelector("input[name='only_owner']:checked");
            const carPaidValue = container.querySelector("input[name='loan_paid_off']:checked");

            if(ownCarValue.value && ownerValue.value && carPaidValue.value){
                if(calcVersion == 'v3'){
                    const useCarValue = container.querySelector("input[name='use_car']:checked");
                    if(useCarValue){
                        nextButton.classList.remove("disabled");
                    }
                }else{
                    nextButton.classList.remove("disabled");
                }
            }
        }
    }

    function showNextStep(e){
        e.preventDefault();
        if(nextButton.classList.contains("disabled")){
            return;
        }
        errorMsg.textContent = "";
        errorMsg.style.display = "none";
        fields.forEach( (e) => {
            e.classList.remove("error");
        });
        let cont = false;
        switch(formStep){
            case 0:
                if(calcVersion != 'default'){
                    if(loanAmountRange.value && !container.querySelector("input[name='loan_paid_off']:checked")){
                        if(calcVersion == 'v3'){
                            container.querySelector("input[name='use_car']").closest('fieldset').style.display = "block";
                        }else{
                            container.querySelector("input[name='loan_paid_off']").closest('fieldset').style.display = "block";
                        }
                        loanAmountRange.closest('fieldset').style.display = "none";
                        container.querySelector("input[name='own_car']").closest('fieldset').style.display = "none";
                        nextButton.classList.add("disabled");
                    }else{
                        cont = "true";
                    }
                }else{
                    cont = (loanAmount.value);
                }
                break;
            case 1:
                cont = true;
                break;
        }
        if(cont && formStep == 0){
            steps.forEach( (e) => {
                e.style.display = "none";
            });
            const carPaidValue = container.querySelector("input[name='loan_paid_off']:checked");
            const soleOwnerValue = container.querySelector("input[name='only_owner']:checked");
            let prequal = (carPaidValue.value == 'yes' && soleOwnerValue.value == 'yes');
            if(calcVersion != 'default'){
                const ownCarValue = container.querySelector("input[name='own_car']:checked");
                prequal = (carPaidValue.value == 'yes' && soleOwnerValue.value == 'yes' && ownCarValue.value == 'yes');
            }
            if(prequal){
                nextButton.classList.add("disabled");
                formStep++;
                nextButton.textContent = searchText;
                container.querySelector("#step" + formStep).style.display = "block";
            }else{
                showDeclined();
            }
        }else if(cont && formStep > 0){
            switch(container.querySelector('input[name="car_lookup"]:checked').value){
                case 'manual':
                    validateVehicle(
                        carYear.querySelector("option:checked").value, 
                        carMake.querySelector("option:checked").value, 
                        carMake.querySelector("option:checked").text, 
                        carModel.querySelector("option:checked").value,
                        carModel.querySelector("option:checked").text,
                        carTrim.querySelector("option:checked").value,
                        carTrim.querySelector("option:checked").text, 
                        carMileage.value.replace(",", ""), 
                        carZip.value,
                        "MANUAL",
                        null,
                        null,
                        null
                    );
                    break;
                case 'license':
                    if(formStep == 1){
                        if(confirmZip.value){
                            console.log(formStep)
                            console.log('execute here')
                            console.log('[splcalc] license branch', {
                            formStep,
                            confirmZip: confirmZip.value,
                            selectedYear,
                            selectedMakeId,
                            selectedModelId,
                            selectedTrimId,
                            selectedVendorId,
                            selectedVin,
                            licensePlate: licensePlate.value,
                            licenseState: licenseState.querySelector("option:checked")?.value
                            });
                            validateVehicle(
                                selectedYear, 
                                selectedMakeId, 
                                selectedMakeStr, 
                                selectedModelId,
                                selectedModelStr,
                                selectedTrimId,
                                selectedTrimStr,
                                confirmMileage.value.replace(",", ""),
                                confirmZip.value,
                                "CF",
                                licensePlate.value,
                                licenseState.querySelector("option:checked").value,
                                selectedVin,
                                selectedVendorId
                            );
                        }else{
                            console.log('execute here too')
                            licenseValidate(
                                licensePlate.value,
                                licenseState.querySelector("option:checked").value
                            );
                        }
                    }
                    break;
                case 'vin':
                    if(formStep == 1){
                        if(confirmZip.value){
                            validateVehicle(
                                selectedYear, 
                                selectedMakeId, 
                                selectedMakeStr, 
                                selectedModelId,
                                selectedModelStr,
                                selectedTrimId,
                                selectedTrimStr,
                                confirmMileage.value.replace(",", ""),
                                confirmZip.value,
                                "VIN",
                                null,
                                null,
                                vinNumber.value,
                                null
                            );
                        }else{
                            vinValidate(vinNumber.value);
                        }
                    }
                    break;
            }
        }else{
            switch(formStep){
                case 0:
                    errorMsg.style.display = "block";
                    if(!soleOwner.value){
                        soleOwner.classList.add("error");
                    }
                    if(!loanAmount.value){
                        loanAmount.classList.add("error");
                    }
                    break;
            }
        }
    }

    function reset(e){
        e.preventDefault();
        errorMsg.textContent = "";
        errorMsg.style.display = "none";
        fields.forEach( (field) => {
            field.classList.remove("error");
        });
        formStep = 0;
        selectedYear = 0;
        selectedMakeId = 0;
        selectedMakeStr = "";
        selectedModelId = 0;
        selectedModelStr = "";
        selectedTrimId = 0;
        selectedTrimStr = "";
        selectedVin = 0;
        selectedVendorId = 0;
        no_collateral.style.display = "none";
        no_collateralHeader.style.display = "none";
        approved.style.display = "none";
        approvedHeader.style.display = "none";
        vehicleConfirm.style.display = "none";
        headings.forEach( (e) => {
            e.style.display = "none";
        });
        fieldsets.forEach( (e) => {
            e.classList.remove('has-value');
        })
        if(calcVersion == "default"){
            container.querySelector('[data-splcalc-id="only_owner_yes"]').checked = true;
            container.querySelector('[data-splcalc-id="loan_paid_off_yes"]').checked = true;
            loanAmount.value = "";
        }else{
            if(calcVersion == "v2" || calcVersion == "v3"){
                ownCar.forEach((radio) => {
                    radio.checked = false;
                });

                carPaid.forEach((radio) => {
                    radio.checked = false;
                });

                soleOwner.forEach((radio) => {
                    radio.checked = false;
                });

                loanAmountRange.value = 18500;
                barColor(loanAmountRange);
                container.querySelector("input[name='loan_paid_off']").closest('fieldset').style.display = "none";
                container.querySelector("input[name='only_owner']").closest("fieldset").style.display = "none";
                loanAmountRangeChange = false;
                container.querySelector("input[name='own_car']").closest('fieldset').style.display = "block";
                loanAmountRange.closest('fieldset').style.display = "block";
                if (calcVersion == "v3") {
                    useCar.forEach((radio) => {
                        radio.checked = false;
                    });
                    container.querySelector("input[name='use_car']").closest('fieldset').style.display = "none";
                }
            }else if(calcVersion == "v4"){
                formStep = 1;
                container.querySelector("#step" + formStep).style.display = "block"; 
            }
        }
        headings.forEach( (e) => {
            e.style.display = "block";
        })
        container.querySelector("#step" + formStep).style.display = "block";

        getYears();
        carMileage.value = "";
        carZip.value = "";
        vinNumber.value = "";
        licensePlate.value = "";
        getStates();

        confirmMileage.value = "";
        confirmZip.value = "";

        container.querySelector('[data-splcalc-id="license"]').checked = true;
        entryTypes.forEach( (div) => {
            div.style.display = "none";
        });
        container.querySelector('.license-fields').style.display = "flex";

        nextButton.classList.add("disabled");
        nextButton.style.display = "inline-block";
    }

    function resetConfirm(e){
        e.preventDefault();
        vehicleConfirm.style.display = "none";
        vinNumber.value = "";
        licensePlate.value = "";
        getStates();
        confirmMileage.value = "";
        confirmZip.value = "";
        nextButton.classList.add("disabled");
        nextButton.textContent = searchText;
    }

    function showDeclined(){
        headings.forEach( (e) => {
            e.style.display = "none";
        });
        steps.forEach( (e) => {
            e.style.display = "none";
        });
        nextButton.style.display = "none";
        no_collateral.style.display = "block";
        no_collateralHeader.style.display = "block";
    }

    function showApproved(range){
        headings.forEach( (e) => {
            e.style.display = "none";
        });
        steps.forEach( (e) => {
            e.style.display = "none";
        });
        nextButton.style.display = "none";
        approvedRange.textContent = range;
        approved.style.display = "block";
        approvedHeader.style.display = "block";
    }

    function trackCustomerVehicleEvaluation(evaluationId){
        if(!evaluationId) return;
        if (!window.utag || typeof window.utag.link !== 'function') return;

        const utagData = (window.utag && window.utag.data) || {};
        const applicationType = utagData.application_type || 'CORPORATE_WEBSITE';
        const stickyVars = (window.teal && window.teal.data && window.teal.data.sticky_variables) || {};
        const payload = {
            application_type: applicationType,
            event_category: applicationType,
            event_attr3: evaluationId,
            element_name: 'customer vehicle evaluation id',
            element_type: 'result',
            tealium_event: 'spl_calculator_customer_vehicle_evaluation_id',
            element_location: 'spl_calculator',
            page_location: window.location.pathname || '/',
        };

        try {
            window.utag.link(payload);
        } catch (e) { }
        
        if (!window.amplitude || typeof window.amplitude.track !== 'function') return;

        window.amplitude.track('Precision SPL Calculator', {
            page_location: window.location.href,
            page_path: window.location.pathname,
            page_title: document.title,
            referrer: document.referrer || '',
            application_type: applicationType,
            application_id: stickyVars.application_id || null,
            client_id: stickyVars.client_id || null,
            component: 'spl-calculator',
            field: 'customer vehicle evaluation id',
            value: evaluationId,
        });

    }

    function togglePlaceholder(field) {
        const fieldset = field.closest("fieldset");
        if (!fieldset) return;

        // Special handling for select
        if (field.tagName === "SELECT") {
            if (field.selectedIndex > 0) {
                fieldset.classList.add("has-value");
            } else {
                fieldset.classList.remove("has-value");
            }
        } else {
            if (field.value.trim() !== "") {
                fieldset.classList.add("has-value");
            } else {
                fieldset.classList.remove("has-value");
            }
        }
    }

    /*API Calls*/
    function getYears(){
        nextButton.classList.add("disabled");
        carYear.length = 1;
        carYear.options[0].disabled = false;
        splCalcFetch('/wp-json/splcalc/vehicle-years')
        .then(async (response) => {
            if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((years) => {
            carMake.length = 1;
            carMake.disabled = true;
            carMake.options[0].disabled = false;
            carModel.length = 1;
            carModel.disabled = true;
            carModel.options[0].disabled = false;
            carTrim.length = 1;
            carTrim.disabled = true;
            carTrim.options[0].disabled = false;
            years.data.forEach(year => {
                const option = new Option(year, year);
                carYear.add(option);
            });
        })
        .catch((error) => {
            console.error('Request failed:', error);
        });
    }

    function getMakes(year){
        carYear.options[0].disabled = true;
        nextButton.classList.add("disabled");
        overlay.classList.add("active");
        splCalcFetch('/wp-json/splcalc/vehicle-make?year=' + year)
        .then(async (response) => {
            if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((makes) => {
            carMake.length = 1;
            carMake.options[0].disabled = false;
            carModel.length = 1;
            carModel.disabled = true;
            carModel.options[0].disabled = false;
            carTrim.length = 1;
            carTrim.disabled = true;
            carTrim.options[0].disabled = false;
            makes.data.forEach(make => {
                const option = new Option(make.makeName, make.id);
                carMake.add(option);
            });
            carMake.disabled = false;
            overlay.classList.remove("active");
        })
        .catch((error) => {
            console.error('Request failed:', error);
        });
    }

    function getTrim(year, make, model){
        carModel.options[0].disabled = true;
        nextButton.classList.add("disabled");
        overlay.classList.add("active");
        splCalcFetch('/wp-json/splcalc/vehicle-trim?year=' + year + '&make=' + make + '&model=' + model)
        .then(async (response) => {
            if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((trims) => {
            carTrim.length = 1;
            carTrim.options[0].disabled = false;
            trims.data.forEach(trim => {
                const option = new Option(trim.trimName, trim.id);
                carTrim.add(option);
            });
            carTrim.disabled = false;
            overlay.classList.remove("active");
        })
        .catch((error) => {
            console.error('Request failed:', error);
        });
    }

    function getStates(){
        licenseState.length = 1;
        licenseState.options[0].disabled = false;
        splCalcFetch('/wp-json/splcalc/license-states')
        .then(async (response) => {
            if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((states) => {
            states.values.forEach(state => {
                const option = new Option(state.key, state.key);
                licenseState.add(option);
            });
        })
        .catch((error) => {
            console.error('Request failed:', error);
        });
    }

    async function getModels(year, make, send = false) {
        carMake.options[0].disabled = true;
        nextButton.classList.add("disabled");
        if(!send){
            overlay.classList.add("active");
        }

        try {
            const response = await splCalcFetch('/wp-json/splcalc/vehicle-model?year=' + year + '&make=' + make);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const models = await response.json();

            if (send) {
                console.log("Get String:", models);
                return models;
            }

            carModel.length = 1;
            carModel.options[0].disabled = false;
            carTrim.length = 1;
            carTrim.disabled = true;
            carTrim.options[0].disabled = false;

            models.data.forEach((model) => {
                const option = new Option(model.modelName, model.id);
                carModel.add(option);
            });

            carModel.disabled = false;
            overlay.classList.remove("active");
            return models;
        } catch (error) {
            console.error('Request failed:', error);
            return null;
        }
    }

    async function licenseValidate(plate, state) {
        overlay.classList.add("active");
        try {
            const response = await splCalcFetch('/wp-json/splcalc/license-validate?plate=' + plate + '&state=' + state);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const validation = await response.json();
            console.log('Plate Validation:', validation);

            if (!validation.vehicle){
                overlay.classList.remove("active");
                errorMsg.textContent = noMatch;
                errorMsg.style.display = "block";
                licensePlate.classList.add("error");
                return;
            };

            selectedYear = validation.vehicle.year;
            selectedMakeId = validation.vehicle.makeId;
            selectedModelId = validation.vehicle.modelId;
            selectedTrimId = validation.vehicle.trims[0].id;
            selectedVendorId = validation.vehicle.vendorVehicleId;
            selectedVin = validation.vehicle.vin;

            const models = await getModels(validation.vehicle.year, validation.vehicle.makeId, true);
            if (!models) return;

            let vehicleText = "";

            models.data.forEach((model) => {
                if (model.id == validation.vehicle.modelId) {
                    vehicleText =
                        validation.vehicle.year + " " +
                        model.make.makeName + " " +
                        model.modelName + " " +
                        validation.vehicle.trims[0].trimName;
                    selectedMakeStr = model.make.makeName;
                    selectedModelStr = model.modelName;
                    selectedTrimStr = validation.vehicle.trims[0].trimName
                }
            });

            vehicleTitle.textContent = vehicleText; 
            vehicleConfirm.style.display = "block";
            nextButton.textContent = continueText;
            overlay.classList.remove("active");
        } catch (error) {
            console.error('Request failed:', error);
        }
    }

    async function vinValidate(vin){
        overlay.classList.add("active");
        try {
            const response = await splCalcFetch('/wp-json/splcalc/vin-validate?vin=' + vin);
            const validation = await response.json();

            if (response.status === 400 && validation.id === "invalid") {
                overlay.classList.remove("active");
                errorMsg.textContent = invalidVinText;
                errorMsg.style.display = "block";
                vinNumber.classList.add("error");
                return;
            }

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            console.log('Vin Validation:', validation);

            if (!validation.data){
                overlay.classList.add("active");
                errorMsg.textContent = noMatch;
                errorMsg.style.display = "block";
                vinNumber.classList.add("error");
                return;
            };

            selectedYear = validation.data.year;
            selectedMakeId = validation.data.makeId;
            selectedModelId = validation.data.modelId;
            selectedTrimId = validation.data.trims[0].id;
            selectedVendorId = validation.data.vendorVehicleId;
            selectedVin = validation.data.vin;

            const models = await getModels(validation.data.year, validation.data.makeId, true);
            if (!models) return;

            let vehicleText = "";

            models.data.forEach((model) => {
                if (model.id == validation.data.modelId) {
                    vehicleText =
                        validation.data.year + " " +
                        model.make.makeName + " " +
                        model.modelName + " " +
                        validation.data.trims[0].trimName;
                    selectedMakeStr = model.make.makeName;
                    selectedModelStr = model.modelName;
                    selectedTrimStr = validation.data.trims[0].trimName
                }
            });

            vehicleTitle.textContent = vehicleText; 
            vehicleConfirm.style.display = "block";
            nextButton.textContent = continueText;
            overlay.classList.remove("active");
        } catch (error) {
            console.error('Request failed:', error);
        }
    }

    function validateVehicle(year, make, makeStr, model, modelStr, trim, trimStr, mileage, zip, source, licensePlate, state, vin, vendorId){
        if (callOnce) return;
        callOnce = true;

        overlay.classList.add("active");

        const vehicleValidationParams = new URLSearchParams({
            year,
            make,
            makeStr,
            model,
            modelStr,
            trim,
            trimStr,
            mileage,
            zip,
            source,
            licencePlate: licensePlate,
            state,
            vin,
            vendorId,
            visitorId: utag.data.tealium_visitor_id
        });

        splCalcFetch('/wp-json/splcalc/vehicle-validate?' + vehicleValidationParams.toString())
        .then(async (response) => {
            if (!response.ok && response.status != 400) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((validation) => {
            console.log('Vehicle Validation:', validation);
            if(validation.eligible){
                splApplyLink.setAttribute("href", splApplyLink.getAttribute("href").replace("###ID###", validation.customerVehicleEvaluationId));
                let range = getRange(validation.valuation);
                if(document.documentElement.lang === 'en-US'){
                    approvalCar.textContent = year + " " + makeStr;
                }else{
                    approvalCar.textContent = makeStr + " " + year;
                }
                showApproved(range);
                trackCustomerVehicleEvaluation(validation.customerVehicleEvaluationId);
            }else{
                showDeclined();
            }
        })
        .catch((error) => {
            console.error('Request failed:', error);
        })
        .finally(() => {
            callOnce = false;
            overlay.classList.remove("active");
        });
    }

    function getLoanAmount(lower){
        let desiredLoan = 0;
        if(calcVersion === "v4"){
            return formatter.format(lower);
        }

        if(calcVersion == 'own-car' || calcVersion == 'v2' || calcVersion == 'v3'){
            desiredLoan = loanAmountRange.value;
        }else{
            desiredLoan = loanAmount.value;
        }

        desiredLoan = Number(desiredLoan.replaceAll(',', '').replaceAll('$', ''));

        if(desiredLoan < lower){
            const newLower = Math.floor(desiredLoan / 1000) * 1000;
            if(newLower > 2525){
                return formatter.format(newLower);
            }else{
                return "2,525";
            } 
        }else{
            return formatter.format(lower);
        }
    }

    function getRange(valuation){
        
        switch(rangeType){
            case "mix":
                if(valuation >= 2525 && valuation <= 3000){
                    return "$" + getLoanAmount(2700) + " " + toText + " $7,900";
                }else if(valuation >= 3001 && valuation <= 3600){
                    return "$" + getLoanAmount(3100) + " " + toText + " $8,500";
                }else if(valuation >= 3601 && valuation <= 4300){
                    return "$" + getLoanAmount(3700) + " " + toText + " $9,200";
                }else if(valuation >= 4301 && valuation <= 5100){
                    return "$" + getLoanAmount(4400) + " " + toText + " $10,100";
                }else if(valuation >= 5101 && valuation <= 6300){
                    return "$" + getLoanAmount(5500) + " " + toText + " $11,200";
                }else if(valuation >= 6301 && valuation <= 8400){
                    return "$" + getLoanAmount(7300) + " " + toText + " $12,900";
                }else if(valuation >= 8401 && valuation <= 12700){
                    return "$" + getLoanAmount(10200) + " " + toText + " $16,400";
                }else if(valuation >= 12701){
                    return "$" + getLoanAmount(15200) + " " + toText + " $18,500";
                }
                break;
            case "rtg":
                if(valuation >= 2525 && valuation <= 3000){
                    return "$" + getLoanAmount(5200) + " " + toText + " $9,700";
                }else if(valuation >= 3001 && valuation <= 3600){
                    return "$" + getLoanAmount(5800) + " " + toText + " $10,100";
                }else if(valuation >= 3601 && valuation <= 4300){
                    return "$" + getLoanAmount(6500) + " " + toText + " $10,600";
                }else if(valuation >= 4301 && valuation <= 5100){
                    return "$" + getLoanAmount(7200) + " " + toText + " $11,800";
                }else if(valuation >= 5101 && valuation <= 6300){
                    return "$" + getLoanAmount(8200) + " " + toText + " $13,100";
                }else if(valuation >= 6301 && valuation <= 8400){
                    return "$" + getLoanAmount(10000) + " " + toText + " $15,100";
                }else if(valuation >= 8401 && valuation <= 12700){
                    return "$" + getLoanAmount(12700) + " " + toText + " $17,900";
                }else if(valuation >= 12701){
                    return "$" + getLoanAmount(18100) + " " + toText + " $18,500";
                }
                break;
        }
    }
}
